import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// custom components
import * as Layout from "common/layout";
import CourseBanner from "./CourseBanner";
import CourseList from "./CourseList";

// styling
const { PageContent } = Layout;

const NewBookACourse = () => {
  const [courseFromLocationId, setCourseFromLocationId] = useState<
    number | undefined
  >(undefined);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();

  const [courseList, setCourseList] = useState([]);
  const [loadingCourseList, setLoadingCourseList] = useState(false);
  const [isHighestLevel, setIsHighestLevel] = useState(true);
  // make use of ComponentWillMount to initiate states for CourseBanner
  if (!mounted) {
    const { state }: { state: any } = location;
    if (state?.course) {
      setCourseFromLocationId(state.course.id);
      setMounted(true);
    }
  }

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    document.title = "LTL Flexi Classes - Full Courses";
  });

  return (
    <PageContent>
      <CourseBanner
        setCourseList={setCourseList}
        setLoadingCourseList={setLoadingCourseList}
        courseFromLocationId={courseFromLocationId}
        setIsHighestLevel={setIsHighestLevel}
      />
      <CourseList
        courseList={courseList}
        loadingCourseList={loadingCourseList}
        courseFromLocationId={courseFromLocationId}
        setCourseFromLocationId={setCourseFromLocationId}
        isHighestLevel={isHighestLevel}
      />
    </PageContent>
  );
};

export default NewBookACourse;
